import React, { Component } from "react";
import Header4 from "src/components/Header/Header4";
import "./index.css";
import { List, Pagination, message, Modal, Image, Select } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import Globe from "../../../../../Globe/index";
import { showPicAtOrder } from "../../../../../GlobeTool/utils";
import pic from "../img/pic.png";
import { connect } from "react-redux";

class FutureListItemDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentOrderID: null,
      proOrderList: [],
      proOrderListCopy: [],
      page: 1,
      openDetail: false,
      displayItem: {},
      openFlag: [],
      orderStatus: "所有",
    };
  }

  componentDidMount() {
    let data = this.props.location.state;
    if (data) {
      this.setState({
        parentOrderID: data.parentOrderID,
        proOrderList: data.proOrderList,
        proOrderListCopy: data.proOrderList,
        openFlag: new Array(data.proOrderList.length).fill([{}, false]),
      });
      window.localStorage.setItem("parentOrderID", data.parentOrderID);
      window.localStorage.setItem(
        "proOrderList",
        JSON.stringify(data.proOrderList)
      );
    } else if (
      window.localStorage.getItem("parentOrderID") &&
      window.localStorage.getItem("proOrderList")
    ) {
      this.setState({
        parentOrderID: window.localStorage.getItem("parentOrderID"),
        proOrderList: JSON.parse(window.localStorage.getItem("proOrderList")),
        proOrderListCopy: JSON.parse(
          window.localStorage.getItem("proOrderList")
        ),
        openFlag: new Array(
          JSON.parse(window.localStorage.getItem("proOrderList")).length
        ).fill([{}, false]),
      });
    }
    let count = 10000;
    let timer = setInterval(() => {
      if (count <= 0) clearInterval(timer);
      if (window.earth && window.Geovis && window.earth.scene) {
        this.returnNowPosition2();
        clearInterval(timer);
      }
      count -= 1;
    }, 10);
  }

  returnNowPosition2 = async () => {
    let nowPosition = [
      116.50347360364503, 40.23798410645239, 116.71592960364503,
      40.3996010645239,
    ];
    this.flyToPosition(nowPosition);
  };
  flyToPosition = async (data, height = 400000) => {
    let positions = [0, 0, 0, 0];
    positions = await data;
    if (positions) {
      window.earth.camera.setView({
        destination: window.Geovis.Cartesian3.fromDegrees(
          (positions[0] + positions[2]) / 2.0,
          (positions[1] + positions[3]) / 2.0,
          height
        ),
      });
    }
  };

  _renderListItem = (item, index) => {
    if (item.orderStatus === "任务完成") {
      return (
        <div className="produce-order-list-item2">
          <Image
            className="produce-order-list-item2-img"
            src={"/zdTiles" + item.InfoProReturnPath}
            onError={this._onImgError}
            preview={false}
          ></Image>
          <div className="produce-order-list-item2-body">
            <div className="produce-order-list-item2-text">
              <span className="produce-order-list-item2-title">
                {item.proOrderId}
              </span>
              <span className="produce-order-list-item2-detail">
                {item.orderChName}
              </span>
              <div className="produce-order-list-item2-bottom">
                <span className="produce-order-list-item2-detail">
                  {moment(item.orderSubmitTime).format("yyyy-MM-DD HH:mm:ss")}
                </span>
                <span className="produce-order-list-item2-detail">
                  发布状态：{item.publishType}
                </span>
              </div>
            </div>
            <div style={{ display: "flex", gap: "1rem" }}>
              <span
                className="produce-order-list-item2-button"
                // onClick={() => this._showProductDetail(item)}
                onClick={() => {
                  this.setState({ openDetail: true, displayItem: item });
                }}
              >
                详情
              </span>
              <span
                className="produce-order-list-item2-button"
                onClick={() => this.showPic(item, index)}
              >
                贴图
              </span>
              <span
                className="produce-order-list-item2-button"
                onClick={() => this.openClient([item])}
              >
                下载
              </span>
              <span
                className="produce-order-list-item2-button"
                onClick={() => this.createInspect(item)}
              >
                检验
              </span>
              <span
                className="produce-order-list-item2-button"
                onClick={() => this.publishProduction(item)}
              >
                发布
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="produce-order-list-item1">
          <div className="produce-order-list-item1-left">
            <span className="produce-order-list-item1-orderChName">
              订单号：{item.proOrderId}
            </span>
            <span className="produce-order-list-item1-orderSubmitTime">
              下单时间：{moment(item.orderSubmitTime).format("yyyy-MM-DD")}
            </span>
          </div>
          <span className="produce-order-list-item1-right">
            {item.orderStatus}
          </span>
        </div>
      );
    }
  };

  showPic = async (item, index) => {
    let dataName = item.dataURL.split("/").pop();
    let res = await axios.get(
      `/gateway/api/interface/api/getSatelliteDetailDatas?name=${dataName}`,
      {
        headers: {
          Authorization: this.props.zd_user.token,
        },
      }
    );
    let dataDetail = res.data.data;
    let position = [
      dataDetail.datalowerleftlong,
      dataDetail.datalowerleftlat,
      dataDetail.dataupperrightlong,
      dataDetail.dataupperrightlat,
    ];
    let temp = showPicAtOrder(
      "/zdTiles" + item.InfoProReturnPath,
      position,
      this.state.openFlag,
      index
    );
    let temp1 = this.state.openFlag;
    temp1[index] = temp;
    this.setState({ openFlag: temp1 });
  };

  //2023.05.10 这里之后需要做几件事
  //   （1）检测当前电脑是否已安装客户端。half
  // （2）未安装跳下载链接，让客户安装。
  // （3）如果安装，检测客户端，想办法让它以当前用户启动。
  // （4）如已启动，将之前点击下载的订单（一个订单或一个订单列表），一同在下载中下载（或者分开，必须在已启动状态下点击下载，才会将链接交互至客户端让其下载。）
  //1、打开客户端
  openClient = (data) => {
    //通过这个循环保证修改每个订单的下载状态
    // console.log('openClient',data)
    let flag = true;
    data.map((item) => {
      if (!item.dataURL) flag = false;
      item.orderDownloadAddr =
        "https://caplos.aircas.ac.cn/zdTiles" + item.dataURL;
      item.fileName = "产品生产结果" + new Date().getTime();
      item.orderId = item.proOrderId;
    });
    console.log("cccc", data);
    if (!flag) {
      message.error("下载订单内含有没有文件地址的订单，请确认订单完成后重试！");
      return;
    }
    // return;
    let _this = this;
    const linkTmp = document.createElement("a");
    linkTmp.href = "ydspacebasedbee://";

    linkTmp.onclick = function (e) {
      _this.callapp_openClient({
        data: data,
        callbackTrue: function (dataT) {
          message.success("准备打开客户端，正在预备下载！");
          _this.createWSForSimple(data);
        },
        callbackFlase: function () {
          message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
          console.log("客户端打开失败！");
        },
      });
    };
    linkTmp.click();
  };

  createInspect = async (item) => {
    debugger
    this.setState({ isLoading: true });
    let dataName = item.dataURL.split("/").pop();
    let res = await axios.get(
      `/gateway/api/interface/api/getSatelliteDetailDatas?name=${dataName}`,
      {
        headers: {
          Authorization: this.props.zd_user.token,
        },
      }
    );
    let data = res.data.data;
    let sendData = {
      producename: data.producename,
      producetime: data.producetime, //产品日期
      producetype: data.producetype,
      productName: data.name,
      satellite: data.satelliteid,
      sensors: data.sensorid,
      userId: this.props.user.userId,

      // productId: parseInt(data.produceid), //产品id
      // productSubId: 0,                     //产品子类id
      // productDownloadUrl: '',              //产品下载链接 ?
      // metaDataVO: { ...data },               //产品上传元数据信息 ?
      // source: 0,                          //来源 0代表门户
      // satelliteId: data.satelliteid,		//卫星id
      // satelliteLoadId: data.sensorid,		//载荷id
      // outsideId: '',		                //外部关联订单id  ?
      // informAddress: '',		            //外部通知地址 ?
      // landCoverTypeVOList: [],		    //地表覆盖类型信息 ?
      // imageValue: 0,                       //int		影像值 ?
      // coverName: rules.selectMode,	     //string		覆盖类型 ?
      // pixelUnit: '',	                    //string		土壤水分像元值单位 ?
      // unitCoefficient: '',	                //string		容重系数 ?
    };
    axios
      .post(
        global.gatewayip + `/api/interface/lxy/saveTempProductData`,
        sendData
      )
      .then((res) => {
        debugger
        console.log("saveTempProductData", res);
        if (res.data.code === "200") {
          this.props.history.push("/GXWBCPJY" + `?id=${res.data.data}`)
          // this.props.pushPage("/GXWBCPJY", res.data.data);
          this.setState({ isLoading: false });
        } else {
          message.error(`检验订单提交失败，失败原因为：${res.data.message}`);
        }
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        message.error("检验订单提交失败，请检查网络连接……");
        console.log(e);
      });
  };

  publishProduction = (item) => {
    console.log(item);
    this.setState({ isLoading: true });
    let data = {
      dataUrl: item.dataURL,
      parentOrderId: this.props.parentOrderID,
      proOrderId: item.proOrderId,
      userName: this.props.user.userName,
      imgUrl: "/zdTiles" + item.InfoProReturnPath,
    };
    axios
      .post(global.gatewayip + `/api/tms/prod2tms/publish`, data)
      .then((res) => {
        if (res.data.code === "200") {
          item.publishType = res.data.message;
          message.success("发布操作成功");
          this.setState({ isLoading: false });
        }
      })
      .catch((e) => {
        message.error("发布操作失败");
        this.setState({ isLoading: false });
      });
  };

  //确认客户端是否被打开的回调函数（感觉有点离谱，但是暂时确实想不到更好的办法，好像百度网盘也是类似的逻辑）
  callapp_openClient({ data, callbackTrue, callbackFlase }) {
    var t = setTimeout(callbackFlase, 1000);
    var inp = document.createElement("input");
    inp.style.position = "absolute";
    inp.style.clip = "rect(0, 0, 0, 0)";
    // 出现下载框的时候往下跳的问题
    inp.style.top = "0";
    inp.style.left = "0";

    // inp.style.display="none";
    function blur() {
      window.clearTimeout(t);
      callbackTrue(data);
    }

    inp.addEventListener("blur", blur); // 监听blur事件
    document.body.appendChild(inp);
    inp.focus(); // 获取焦点
    setTimeout(function () {
      // 删除无用的标签
      inp.removeEventListener("blur", blur);
      document.body.removeChild(inp);
    }, 1000);
    //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
    //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
  }

  createWSForSimple = (data) => {
    let _this = this;
    this.webSocketClient = new WebSocket("ws://127.0.0.1:9312"); // 新建一个WebSocket通信，连接一个本地服务器
    this.webSocketClient.onopen = function (e) {
      //连接建立时触发函数
      console.log(
        "网站ws通讯已创建，目前状态为：" + _this.webSocketClient.readyState
      );
      clearInterval(_this.wsTimer);
      _this.setState({ wsToClientTimerFlag: true });
      if (_this.webSocketClient.readyState === 1) {
        _this.wsSendMessage(JSON.stringify({ type: "download", data: data })); //传送消息
      }
    };
    this.webSocketClient.onmessage = function (evt) {
      //客户端接收服务端数据时触发
      console.log("网站接收到了来自客户端的消息：", evt); //向页面追加显示服务端发送给客户端的消息
    };
    this.webSocketClient.onclose = function (evt) {
      //连接关闭时触发
      console.log("网站的连接通关已关闭!", evt);
      if (_this.state.wsToClientTimerFlag) {
        let nowTimer = 0;
        let timeCount = 500;
        let maxTimer = 15000;
        _this.wsTimer = setInterval(() => {
          _this.createWSForSimple(data);
          nowTimer += timeCount;
          console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
          if (nowTimer >= maxTimer) {
            clearInterval(_this.wsTimer);
            console.log("网站尝试连接客户端重试结束……");
          }
        }, timeCount);
        _this.setState({ wsToClientTimerFlag: false });
      }
    };
  };

  wsSendMessage = (mes) => {
    //向服务端发送消息
    console.log("wsSendMessage", mes);
    this.webSocketClient.send(mes); //传送消息
  };

  _onImgError = (e) => {
    console.log("zxx", e.target.src);
    e.target.src = pic;
    // e.target.onerror
    // console.log('ceshi',String(e.target.onerror))
  };

  handleChange = (value) => {
    let list = [];
    if (value === "所有") list = this.state.proOrderList;
    else
      list = this.state.proOrderList.filter(
        (item) => item.orderStatus === value
      );
    this.setState({ orderStatus: value, page: 1, proOrderListCopy: list });
  };
  render() {
    let { parentOrderID, proOrderListCopy, page, displayItem } = this.state;
    return (
      <div className="Download-list-item-detail">
        <Header4 />
        <div className="usercenter-main" style={{ padding: "0" }}>
          <div className="usercenter-continer">
            <div className="Download-list-item-detail-content">
              <div className="Download-list-item-detail-content-header">
                <div className="Download-list-item-detail-content-header-left">
                  <LeftOutlined
                    className="Download-list-item-detail-content-header-left-back"
                    onClick={() => this.props.history.goBack()}
                  />
                  <div className="Download-list-item-detail-content-header-left-title">
                    {parentOrderID}
                  </div>
                </div>
              </div>
              <div className="produce-order-globe" style={{ margin: "0" }}>
                <Globe morphTo2D={true}></Globe>
              </div>
              <div className="Future-list-item-search">
                <Select
                  style={{ width: "10%" }}
                  options={[
                    {
                      value: "所有",
                      label: "所有",
                    },
                    {
                      value: "等待处理",
                      label: "等待处理",
                    },
                    {
                      value: "处理中",
                      label: "处理中",
                    },
                    {
                      value: "任务完成",
                      label: "任务完成",
                    },
                    {
                      value: "受理异常",
                      label: "受理异常",
                    },
                  ]}
                  value={this.state.orderStatus}
                  onChange={(value) => this.handleChange(value)}
                ></Select>
              </div>
              <div className="Future-list-item-detail-content-list-wrap">
                <div className="Download-list-item-detail-content-list">
                  <List
                    dataSource={proOrderListCopy.slice(
                      (page - 1) * 10,
                      page * 10
                    )}
                    renderItem={this._renderListItem}
                    split={false}
                    size="small"
                  />
                </div>
                <div className="Download-list-item-detail-content-pagination">
                  <Pagination
                    current={page}
                    total={proOrderListCopy.length}
                    onChange={(page, pageSize) => this.setState({ page })}
                    showTotal={(total) => `共 ${total} 条`}
                    showSizeChanger={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="订单详情"
          visible={this.state.openDetail}
          mask={true}
          onOk={() => this.setState({ openDetail: false })}
          cancelButtonProps={null}
          footer={null}
          onCancel={() => this.setState({ openDetail: false })}
          className="detail_dialog"
        >
          <div className="detail_content">
            <div className="detail_first_line">
              <img
                className="product_image"
                src={"/zdTiles" + displayItem.InfoProReturnPath}
                alt="图片未入库"
              />
              <div className="product_title">
                <div className="product_title_font">
                  {displayItem.proOrderId}
                </div>
                <div className="product_title_content_font">
                  流程名 : {displayItem.orderChName}
                </div>
                <div className="product_title_content_font">
                  卫星 : {displayItem.satellite}
                </div>
                <div className="product_title_content_font">
                  传感器 : {displayItem.sensors}
                </div>
              </div>
            </div>
            <div className="detail_second_line">
              <table className="product_description_table">
                <tbody>
                  <tr>
                    <td className="first_td">订单状态 :</td>
                    <td>{displayItem.orderStatus}</td>
                  </tr>
                  <tr>
                    <td className="first_td">订单驱动类型 :</td>
                    <td>{displayItem.orderDriveType}</td>
                  </tr>
                  <tr>
                    <td className="first_td">订单开始时间 :</td>
                    <td>
                      {displayItem.orderStartTime &&
                        displayItem.orderStartTime.slice(0, 10)}
                    </td>
                  </tr>
                  <tr>
                    <td className="first_td">订单提交时间 :</td>
                    <td>
                      {displayItem.orderSubmitTime &&
                        displayItem.orderSubmitTime.slice(0, 10)}
                    </td>
                  </tr>
                  <tr>
                    <td className="first_td">订单结束时间 :</td>
                    <td>
                      {displayItem.orderEndTime &&
                        displayItem.orderEndTime.slice(0, 10)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapState = (state) => ({
  //返回值  对应的是  组件的props
  user: state.userReducer.get("user").toJS(),
  zd_user: state.userReducer.get("zd_user").toJS(),
});
const mapDispatch = (dispatch, ownProps) => ({});

export default connect(mapState, mapDispatch)(FutureListItemDetail);
